import { useId } from "react";

import { Checkbox } from "~/components/ui/checkbox";
import { FormField } from "~/components/ui/form-field";

import { useFieldContext } from "./field-context";
import { useFieldError } from "./field-errors";

export function CheckboxField({
  label,
  helpText,
  children,
}: {
  label?: string;
  helpText?: string;
  children?: React.ReactNode;
}) {
  const field = useFieldContext<boolean | null | undefined>();
  const error = useFieldError(field.name);
  const id = useId();
  return (
    <FormField
      inputId={id}
      label={label}
      helpText={helpText}
      error={error}
      checkbox
    >
      <Checkbox
        id={id}
        checked={field.state.value ?? false}
        onCheckedChange={(c) => field.handleChange(c === true)}
      >
        {children}
      </Checkbox>
    </FormField>
  );
}
